export enum CertificateType {
	COMMERCIAL = 'commercial',
	SUKL = 'sukl',
	P1_WORKPLACE_TLS = 'p1_workplace_tls',
	P1_WORKPLACE_WSS = 'p1_workplace_wss',
}
